module.exports = __webpack_public_path__ + "img/logo.7ea851ad.jpg";